import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'cdk-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
	isOpen: boolean = false;
	user: any;
  	//currentUser = null;
  	Hari;


  	@Input() currentUser = null;
  	@HostListener('document:click', ['$event', '$event.target'])
  	onClick(event: MouseEvent, targetElement: HTMLElement) {
    	if (!targetElement) {
     		return;
    	}

    	const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    	if (!clickedInside) {
      		this.isOpen = false;
    	}
  	}


  	constructor(private elementRef: ElementRef) { }

  	logout() {
  		sessionStorage.setItem('Auth', 'false');
  		sessionStorage.removeItem('User');
	}



  	ngOnInit() {
  		this.user = JSON.parse(sessionStorage.getItem('User'));
		console.log(JSON.parse(sessionStorage.getItem('User')), 'USUARIO');
  	}

}
